// TODO - Replace with @qbe/ui-qbe-icons and @qbe/ui-icon

import React from 'react';
import { toSitecoreUrl } from 'utils/toSitecoreUrl';

export interface IconProps {
  name: IconName;
  width?: number | string;
  height?: number | string;
  alt?: string;
  className?: string;
}

export const imgMap = {
  question: toSitecoreUrl('21DE5E1A403C4EDDAA251ACDF92F7ACE'),
  expandIcon: toSitecoreUrl('CBD0FD23B9C84485BD54B34E26C514C7'),
  cancel: toSitecoreUrl('43B6742190244365B9A9F030AFC512C8'),
  cancelWhite: toSitecoreUrl('9BE6DC88636645889BFB64B914D5E1D7'),
  woodworking: toSitecoreUrl('A661668CE6E54AD1B7E89725061F5821'),
  warningOrange: toSitecoreUrl('2CE07AF7554B4659B9D7695F5989D36B'),
  elders: toSitecoreUrl('3E2825C04F564A07A80909F614A3C02F'),
  insuranceCouncil: toSitecoreUrl('4FFA90BAC3A54F84BA6D3B546C7D575D'),
  textFieldSuccess: toSitecoreUrl('889397A7DB9B424DB60656826BFAED86'),
  textFieldWarning: toSitecoreUrl('92B0A2E6261342D39BD505AFD2FE5455'),
  textFieldError: toSitecoreUrl('41096208A54B4551891CED60A521B503'),
  checkboxGreenTick: toSitecoreUrl('0AACF3A9B1BE43659B556DBDDC430C29'),
  visa: toSitecoreUrl('43FBFA92B3824A28AAF53EF283FD13BC'),
  info: toSitecoreUrl('0C7DF2EF225449C4ACF1E27EFDFDF5E7'),
  mastercard: toSitecoreUrl('5B90DAC7BB554D99A5D16B0A17AAE87B'),
  search: toSitecoreUrl('0FF6233CC76B4C1CABF53A8BDD61684B'),
  close: toSitecoreUrl('7221CF52132A447B8DD9A2D9EF38E74D'),
  mail: toSitecoreUrl('7C9AF27257144A90B133838DCE1D4273'),
  success: toSitecoreUrl('53137237D73A4DFABEA7407D4391E26B'),
  redCross: toSitecoreUrl('8B2C9A1537074EBCB55CCFBEA36363E1'),
  qbeLogo: toSitecoreUrl('2D74F65DD44C49F9A53CB258D9F6DE31'),
  back: toSitecoreUrl('E31A2B58C83046878CD8F81AA1D3BDF0'),
  exit: toSitecoreUrl('52DE1A94B5AC47138A8DB2892D8DD227'),
  addCircle: toSitecoreUrl('C302324AFEF74D599E24BE12F471E64E'),
  edit: toSitecoreUrl('6583AA861568494BA945243B2F1832FF'),
  clear: toSitecoreUrl('378AFD2997A84EC494252DE77A753B12'),
  infoLarge: toSitecoreUrl('7636FA6105DF40DC9783FDFA294B1683'),
  home: toSitecoreUrl('920B10795F064FA0A859016CE6561D54'),
  excessCasuality: toSitecoreUrl('3EE99423ACA54734862776D072B94B27'),
  infoFilled: toSitecoreUrl('5E7A01BE32534997AAC84028D8409821'),
  facebook: toSitecoreUrl('4DA2C7B9CF16487CA818A611B4569C52'),
  instagram: toSitecoreUrl('A699D8608A69417DAB4A22241341AD54'),
  linkedIn: toSitecoreUrl('E12E87BB102845C9AF2F30DC1E7E45AF'),
  twitter: toSitecoreUrl('8A3CAA1620274946A6F8507AABB7140B'),
  youtube: toSitecoreUrl('3BB0C1A682E041EAB26167245E3DDD23'),
  phoneReceiver: toSitecoreUrl('8D8A1F0B56934277A38C18D9D78F26FE'),
  secureAcceptance: toSitecoreUrl('0B8CCABE62404FFC9B0EF856C3853038'),
  amex: toSitecoreUrl('216D73AF291F4FA7A38666E4AC919D96'),
  radioUnselectedLg: toSitecoreUrl('F62E5E5E25644F4A99AB2FB8B17418F0'),
  radioSelectedLg: toSitecoreUrl('C2ACFA997AEE45B0AA9A3EAB8D364AE4'),
  radioPreSelectedLg: toSitecoreUrl('13163822195F4772A5C6A39A4C75085A'),
  accountants: toSitecoreUrl('510183E610FB45B99D411E396DF408E5'),
  advertising: toSitecoreUrl('CB0BF1D509C944898D5A55C08E04FF73'),
  airconditioningAndHeating: toSitecoreUrl('7CEB70703B2F48DC8DE93F0AA83A2511'),
  architectAndBuildingServices: toSitecoreUrl('414187530BD04A49AE2E843DCBFC5018'),
  arts: toSitecoreUrl('AF8DBBB64B5741BFA28A95C23FB6548E'),
  barsHotelsAndClubs: toSitecoreUrl('CAB00AD6B4794434A78051C4AA3AA929'),
  beautyPharmaceuticalRetail: toSitecoreUrl('9D25D5CCAC2C4A0889406B3863B1FF83'),
  businessAdministrativeSupportServices: toSitecoreUrl('762D4895013F4E3C8C52B934C2CABE6E'),
  cafesAndRestaurants: toSitecoreUrl('85CEE0C60FAC4C61802C378F992017BB'),
  carpentingAndWoodworking: toSitecoreUrl('B0AFB437EE0A42A8AB5975BB978F1ABC'),
  cleaningAndPestControl: toSitecoreUrl('192CA63574CE4F09ADD3B7C521B598F7'),
  clothingAndAccessoriesRetail: toSitecoreUrl('1243A10C08D9476DA938E8D5CFB401AC'),
  concretingBricklaying: toSitecoreUrl('6721E7555ACD41E7AAAA8376D7BA8E57'),
  constructionAndSitePreparation: toSitecoreUrl('16FB476223224CF4A45B4CB2ACA665E7'),
  constructionServices: toSitecoreUrl('BFCD2F2C54D3421B91242B68097D46E9'),
  consultants: toSitecoreUrl('CF041502D81B4A268AFBC3B5B36FBD00'),
  electricalAndFireAndSecuritySystems: toSitecoreUrl('B58D2DACDBD5487691809024C92C9D71'),
  electricalRetail: toSitecoreUrl('FBFA879FFAF74241AEAD33B1CBDAB598'),
  finance: toSitecoreUrl('E5B2701F9B02430C8AF8711143D2994D'),
  freightAndTravelServices: toSitecoreUrl('A8B5CC9496AB453F9EEE8D8ACE2E8A0F'),
  furnitureAndAccessoriesRetail: toSitecoreUrl('AEFB0B1AE33C4B71BB4C55D82FA65CE5'),
  gardenRetail: toSitecoreUrl('E2C59821F04C46CEA388EE9EC0D93810'),
  glazing: toSitecoreUrl('7C569E18BC7D4133B3193CF1551B93B0'),
  groceryAndFoodRetail: toSitecoreUrl('807D3715D2D64529B12BA4C0B4FBA186'),
  healthBeautyServices: toSitecoreUrl('92614FF65A8342D98B37B85ED7735419'),
  homewareRetail: toSitecoreUrl('85046706D8A5412AB79D3A44E4282707'),
  householdEquipmentRepair: toSitecoreUrl('FBB61782E1AE4954ACB180C0334380B0'),
  industryAssociations: toSitecoreUrl('093764BD203F4D5E80A99A4EF767DF7D'),
  informationTechnology: toSitecoreUrl('83890DEA09E847CD97FD4DDE743F23FE'),
  insuranceActuarial: toSitecoreUrl('1003F14FDC54473CB04D7850B7F43161'),
  jewelleryRetail: toSitecoreUrl('FA599FBF73B94E5FB164528813B9FE5B'),
  landscapingGardening: toSitecoreUrl('D84EC907FAE9493F9AF2360CD05A4DDD'),
  legalServices: toSitecoreUrl('7096F99F3A02428380CA08B10299C06C'),
  licensedClubsAndVenues: toSitecoreUrl('AFBC8A82B62B4214962023198A941B7F'),
  motorVehicleRetail: toSitecoreUrl('71BA48E985E5442C99FEF2CBA06CB435'),
  other: toSitecoreUrl('ACED6BE7BC294284B230768F3CD7406A'),
  paintingAndDecorating: toSitecoreUrl('DF869B1BA2354E78986C15A35B444B0C'),
  paperProductsRetail: toSitecoreUrl('F77D091B06FA4F78AC25EA45BA79258D'),
  personalServices: toSitecoreUrl('D1A1818C637E4F419094F236BACBA0D8'),
  petrolAndVehicleServicingRetail: toSitecoreUrl('5A76D5A6FD63496FA0E3762E6E9CAC9B'),
  plasteringRenderingCladdingRoofing: toSitecoreUrl('849D865D937E460DA08F445D4ED79662'),
  plumbing: toSitecoreUrl('C1E55904987B4F47AC329BF203F3E81B'),
  realEstater: toSitecoreUrl('E546C08C4727428A969B96A30A9109DD'),
  retailOther: toSitecoreUrl('6D4A1CA4919F45A9B789FAD066C90EB1'),
  secondHandGoodsRetail: toSitecoreUrl('3675B289942C41CEB4271CFAA21632FE'),
  sportToysCampingRetail: toSitecoreUrl('AFC3C72C4201402C84D45B007F93A9CD'),
  takeAwayFoodDrink: toSitecoreUrl('AC74F7169E0B4D539129EC2CC88DC731'),
  tilingCarpetingFlooring: toSitecoreUrl('C0C388B11AB346649BBB4E642B647AA6'),
  agricultureMiningUtilities: toSitecoreUrl('733EFE827C7944E2BCFEFC57824F3D4A'),
  artMedia: toSitecoreUrl('EF73ED7F107646E0863A0A2E3252C48F'),
  foodBeverageHospitality: toSitecoreUrl('96EC53B3AE4F476B91DB6B7E86470777'),
  governmentEducationReligion: toSitecoreUrl('45EAD5F42FB041AF8FF3C6C4A735B096'),
  healthBeauty: toSitecoreUrl('0839128772AC4811ADFE56F6FBF67CF5'),
  manufacturingWholesaling: toSitecoreUrl('6D13036E4C5E4341BEB1E9F8B2D964FA'),
  professionalService: toSitecoreUrl('BE64B620933A471BB5B6EC48BF76E19E'),
  propertyOwnersAccommodation: toSitecoreUrl('822F6E96557A4A24BF6CFD41C5E219EF'),
  retail: toSitecoreUrl('805D81AC17054333BCF00EFC389AC9E6'),
  sportRecreationClubsAssociations: toSitecoreUrl('97D7BC37D5324EA4A1BDA57CE386D5F5'),
  trades: toSitecoreUrl('1E77D9D780DA48FDBEA75797EE6DBCBE'),
  transportLogistics: toSitecoreUrl('A0CA6A9C1673490E978DDFF60EC73975'),
  hairdressingAndBeautyServices: toSitecoreUrl('E12AAE80369C408BA4DA842C104BFD8B'),
  hospitals: toSitecoreUrl('CCE6AB0BEAF54A21B9E1F8B9353CEF3C'),
  nursingHomes: toSitecoreUrl('E6B5BAF409F34EB593F27BE5AE580B56'),
  healthServices: toSitecoreUrl('C83C131D325C48E58D48572CAAD90E1E'),
  specialistMedicalServices: toSitecoreUrl('5D88B86853514FCD89C941B50A2F18CC'),
  dentalServices: toSitecoreUrl('1D715692993D44D9B96DE5EDBEF7D39E'),
  communityHealthCentres: toSitecoreUrl('202332492F10425599C5BBCBE655FF99'),
  optometry: toSitecoreUrl('93CF632D92134B538CAFC1215F241041'),
  veterinaryServices: toSitecoreUrl('5D6B9D02DD76489E81285C2FE659685D'),
  petServices: toSitecoreUrl('B07D448A1E544DBCAE6D995466A178E3'),
  ambulanceServices: toSitecoreUrl('B16A96446C5D400B99BBD920E6E4E800'),
  clock: toSitecoreUrl('A9837F3EAA7F4380AE9EB223F3CD09CA'),
  roadFreightTransport: toSitecoreUrl('79637423E2974D94A83381753ABAEFB4'),
  servicesToRoadTransport: toSitecoreUrl('2D23F5150F4D493BA1FCB39EAC0EEEA2'),
  servicesToAirTransport: toSitecoreUrl('05D97B510F4A420FBCDD16FB5E46C20B'),
  transportOther: toSitecoreUrl('E2A80816B84B43C6A9E264E0A17BE91A'),
  storageFacilities: toSitecoreUrl('4D3EEF172C9F48A6A9CC604F71CEE762'),
  busTransport: toSitecoreUrl('A8C5EBE4B3FD4569A89F5A4E1EB79CE7'),
  freightForwarding: toSitecoreUrl('6DFCA5EFCD5D44CFA97BA2982A3975F1'),
  railWaterAirTransport: toSitecoreUrl('8CB4D7E4BBD6425A9340EFEDB67AB1C9'),
  taxiAndOtherRoadPassengerTransport: toSitecoreUrl('2205B253385749459E5BFE33D4F6458E'),
  servicesToWaterTransport: toSitecoreUrl('C41324B0BA6E46D497FC110F29E9DCED'),
  parkingServices: toSitecoreUrl('BF0CB36486E54DEB9A97D69FBCF6057F'),
  waterTransportTerminals: toSitecoreUrl('959008CD1A02472BB61BDD91DCB4AC3C'),
  videoOrAudio: toSitecoreUrl('18301DF8AEC541258F0F43A31881C7D5'),
  photography: toSitecoreUrl('6BED0134F1A84E46A4DACE4E4DAC008D'),
  visualArtists: toSitecoreUrl('9DAF543299AD4332ADEF5D1C4AB90A76'),
  performanceArt: toSitecoreUrl('72EDDAAA92324BE2890EA77104603320'),
  artsOrMediaEquipmentHire: toSitecoreUrl('F07D336565184AB8AB34672700A01A09'),
  writingOrPublishing: toSitecoreUrl('8E225881E12D4451B1907BFA40F15399'),
  entertainmentVenue: toSitecoreUrl('EB3461EDD162491C9EA3DA978EF25E17'),
  otherArtsOrMediaServices: toSitecoreUrl('42C802D4220147C1B83BCFAFE110F854'),
  archivalServices: toSitecoreUrl('8AC9CB207BFE425B9F060E941062BCC6'),
  gymsStudiosOrOtherFacilities: toSitecoreUrl('CF9849157A194310870864831F5E877E'),
  sportsCentresOrStadiums: toSitecoreUrl('269F1F23CBC94A97A49E69203C6B0148'),
  motorsportsOrFirearms: toSitecoreUrl('A5C49FC5487A4639B9D79E73EBE04A72'),
  otherSportsRecreationOrClubs: toSitecoreUrl('B4426D821AC64E79952ECD9D64EBBE0D'),
  instructorsTrainersOrOutdoorGuides: toSitecoreUrl('1FF876DD53FD46B4BBF3A7F9BC6F617C'),
  communityUnionsOrAssociations: toSitecoreUrl('ECB6035C7CC0482493EA18D9B256BA1F'),
  horsesOrDogs: toSitecoreUrl('4AC0D5905040494A829C46237CC86612'),
  gearAndEquipmentHire: toSitecoreUrl('6A2B0468FABB474A9C2A5E57818296C4'),
  gamesRidesOrEntertainment: toSitecoreUrl('C7B703756334485BB75EEC5AE778CAAB'),
  grassSportsOrWatersports: toSitecoreUrl('CAD3E6703E1A471EBB1ACB3C59905ED1'),
  gambling: toSitecoreUrl('D4A4878F3E5D457E923F0F8061AC0718'),
  parksOrOutdoorRecreationFacilities: toSitecoreUrl('DEF6DB1A670645E8AA8D0AB403DA590B'),
  basicMaterialWholesaling: toSitecoreUrl('5E8E9EBE73674953BCAFED83F4DACECB'),
  chemicalOrFuelProductManufacturing: toSitecoreUrl('DBA257C4F9804D8AB0A5D1A4604ED3D9'),
  clothingOrTextilesManufacturing: toSitecoreUrl('05D2655EE3D14FC698B7E4AD265E35AC'),
  foodOrBeverageManufacturing: toSitecoreUrl('3A52884724A546DD8A41284289B36B09'),
  metalProductManufacturing: toSitecoreUrl('7863711C413E463593DA352451C84B81'),
  mineralNonmetalProductManufacturing: toSitecoreUrl('C950DCC84722479A90431E1C68A9D89F'),
  otherManufacturing: toSitecoreUrl('4ED21C6B06AE4C7099A63C04B7754832'),
  personalOrHouseholdGoodsWholesaling: toSitecoreUrl('A6538D8F45D04E96A060055971353AF2'),
  printOrRecordedMediaManufacturing: toSitecoreUrl('6F1C010AAE8E47C18D33879DF97F0A42'),
  vehicleMachineryOrEquipmentManufacturing: toSitecoreUrl('AAE6E564CF164C9E8F298DC2B81EFFB5'),
  vehicleMachineryOrEquipmentWholesaling: toSitecoreUrl('513E043E3EB2414798EA939E665B2905'),
  woodOrPaperProductManufacturing: toSitecoreUrl('EB40C77C42534E0FBFB0ABAA8A2F44E8'),
  insuredTypeBusinessOperator: toSitecoreUrl('CF847B2D262B4F64993F22966966BFDD'),
  insuredTypeLandlord: toSitecoreUrl('5816D5A6842E4905B79A65A241115FEA'),

  education: toSitecoreUrl('590EE10292934DF5BAFFC8328F36118A'),
  government: toSitecoreUrl('5E7A3639533B4560848532E1608BAF29'),
  religion: toSitecoreUrl('3729E6498A9644B6B9943A8E3AA2C098'),

  agriculture: toSitecoreUrl('1D505F96007B42EBBDCCC1B3DE5827AA'),
  mining: toSitecoreUrl('64C6B09B64BD4CF6B4856C78DB488D75'),
  utilities: toSitecoreUrl('504FB80AF27A43BE8F3B8901E00101F6'),

  accommodation: toSitecoreUrl('787B96A27B854C0AAF17C43B2FCF7FA6'),
  accommodationCategory: toSitecoreUrl('119DCF9047294384BF8DDF32DE0B8E25'),
} as const;

export type IconName = keyof typeof imgMap;

const Icon = React.memo(({ name, width, height, alt, className }: IconProps) => (
  <img src={imgMap[name]} alt={alt || name} width={width} height={height} className={className} />
));
Icon.displayName = 'Icon';

export default Icon;
